export default __webpack_public_path__ + "static/media/fMaltoBuza29.f606899c.png";